import { render } from "./Dropdown.vue?vue&type=template&id=ef531126&scoped=true&bindings={}"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=ef531126&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef531126"

export default script